import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTokenInfo } from "../../../utils/Guard";
import { useNavigate } from "react-router-dom";
import { GetCountries} from "../../../store/country-store/country-actions";
import { countryActions } from "../../../store/country-store/country-slice";
import { Button } from "primereact/button";
import ABADatatable from "../../../components/ABADataTable/ABADatatable";

const CountryHomePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userInfo = getTokenInfo();
  const country = useSelector((state) => state.country);


  useEffect(() => {
    if (userInfo.Roles !== undefined && userInfo.Roles.includes("country.showAll") ) {
      dispatch(GetCountries(userInfo.Email, true));
    }else if (
      userInfo.Roles !== undefined &&
      !userInfo.Roles.includes("country.menu")
    ) {
      window.location.href = "/home";
    }

  }, [dispatch, userInfo.Roles, userInfo.Email]);


  const viewDetailHanlder = (val) => {
    navigate(`/country/detail/${val.id}`);
  };
  const editHanlder = (val) => {
    navigate(`/country/edit/${val.id}`);
  };
  const createHanlder = () => {
    dispatch(
      countryActions.setCountry({
        country: {
          id: 0,
          name: "",
          code: "",
          status: false,
        },
      })
    );
    navigate(`/country/create`);
  };

  const backHanlder = () => {
    navigate(`/`);
  };
  let actions = [];
  const buttons = (rowData) => {
    let buttons = [];
    const buttonEdit = (
      <Button
        label="Editar"
        icon="pi pi-file-edit"
        className="p-button-rounded p-button-success p-button-text"
        onClick={() => {
          editHanlder(rowData);
        }}
      />
    );
    const buttonView = (
      <Button
        label="Ver"
        icon="pi pi-info-circle"
        className="p-button-rounded p-button-text"
        onClick={() => {
          viewDetailHanlder(rowData);
        }}
      />
    );
    if (userInfo.Roles !== undefined && userInfo.Roles.includes("country.edit")) {
      buttons.push(buttonEdit);
    }
    if (userInfo.Roles !== undefined && userInfo.Roles.includes("country.view")) {
      buttons.push(buttonView);
    }
    return buttons;
  };
  actions.push(buttons);

  const columns = [
    {
      field: "name",
      header: "Nombre",
      filterMatchMode: "contains",
    },
    {
      field: "status",
      header: "Estado",
      filterMatchMode: "contains",
    },
  ];

  return (
    <>
    <div style={{ backgroundColor: "#133047", padding: "1%", height: "118vh"}}>
    <ABADatatable
      width="20%"
      title="Países"
      values={country.countries}
      rows={5}
      rowsPerPageOptions={[5, 10, 20]}
      Columns={columns}
      actions={actions}
      createButton={{
        label: "Agregar",
        onClick: createHanlder,
        permission: "country.create",
      }}
      backButton={{
        label: "Regresar",
        onClick: backHanlder,
        permission: "goBack",
      }}
    />
    </div>
  </>
  );
};
export default CountryHomePage;
